import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import history from '@src/history';
import login_user_store from '@store/LoginUser/LoginUserStore';

import { getNavNodeByMatchPath } from '@common/NavConfig'
import { server_root } from '@src/env-config';

@observer
class ProtectedRoute extends React.Component {
  render() {
    const { component: Component, authority, ...res } = this.props;
    // return <Component {...res}/>;
    if( authority === 'admin' && !login_user_store.is_login ) { // 登录后才能访问 && 用户没有登录
      let redirect_path = history.location.pathname;
      // let redirect_path = `/proxy/my-summary/${login_user_store.id}/${login_user_store.pet_name}`;
      if(redirect_path) { // 重定向至 登录页，带上登陆后跳转到 重定向之前的页面路径
        window.location.href = `${server_root}/login.html`;
      } else {
        window.location.href = `${server_root}/login.html`;
      }
      return null;
    } else {

      return <Component {...res}/>;

    }
  }
}

export default ProtectedRoute;



// WEBPACK FOOTER //
// ./src/components/ProtectedRoute/ProtectedRoute.jsx